import { useCallback } from "react";
import { ControllerFieldState } from "react-hook-form";

/**
 * Returns a memoized callback that checks whether a form field value is an
 * AI-suggested value that hasn't been edited by the user. A value is considered
 * suggested when it is truthy and non-empty (null, empty string, and false are
 * excluded), the field hasn't been dirtied, and the parent record's needsReview
 * flag is true.
 *
 * @param needsReview - whether the current record has unreviewed AI-parsed data
 */
export function useSuggestedValue(needsReview: boolean) {
  return useCallback(
    (
      value: string | number | boolean | null,
      fieldState: Pick<ControllerFieldState, "isDirty">
    ) => {
      if (value === null || value === "" || value === false) return false;
      return !fieldState.isDirty && needsReview;
    },
    [needsReview]
  );
}
